import { findLexicalSets, SetName } from "./findLexicalSets";

/** map a lexical set name to replacement phonemes */
export type SetRules = Record<SetName, string>;

/** English in, phonemes out */
export function replaceLexicalSets(english: string, rules: SetRules): string {
  const tokenized = findLexicalSets(english);
  const lookup = rulesToLookup(rules);
  return replaceLexicalTokens(tokenized, lookup);
}

export function replaceLexicalTokens(tokenized: string, lookup: string[]): string {
  let result = '';
  for (let i = 0; i < tokenized.length; i++) {
    const phonemes = checkForToken(tokenized, i, lookup);
    if (phonemes !== undefined) {
      result += phonemes;
      i += 3;
    } else {
      result += tokenized[i];
    }
  }
  return result;
}

function checkForToken(tokenized: string, i: number, lookup: string[]): string | undefined {
  if (tokenized.charAt(i) !== '(' || tokenized.charAt(i + 3) !== ')') {
    return undefined;
  }
  const number = Number.parseInt(tokenized.substring(i + 1, i + 3));
  return lookup[number];
}

/** turn the rules into a simple lookup array */
export function rulesToLookup(rules: SetRules): string[] {
  const lookup: string[] = [];
  lookup[0] = rules.FACE;
  lookup[1] = rules.PRICE;
  lookup[2] = rules.GOAT;
  lookup[3] = rules.CHOICE;
  lookup[4] = rules.MOUTH;
  lookup[5] = rules.START;
  lookup[6] = rules.SQUARE;
  lookup[7] = rules.NEAR;
  lookup[8] = rules.NORTH;
  lookup[9] = rules.FORCE;
  lookup[10] = rules.CURE;
  lookup[11] = rules.lettER;
  lookup[12] = rules.NURSE;
  lookup[13] = rules.PALM;
  lookup[14] = rules.LOT;
  lookup[15] = rules.THOUGHT;
  lookup[16] = rules.CLOTH;
  lookup[17] = rules.TRAP;
  lookup[18] = rules.BATH;
  lookup[19] = rules.DRESS;
  lookup[20] = rules.FLEECE;
  lookup[21] = rules.happY;
  lookup[22] = rules.KIT;
  lookup[23] = rules.GOOSE;
  lookup[24] = rules.FOOT;
  lookup[25] = rules.STRUT;
  lookup[26] = rules.commA;
  return lookup;
}
